import { get, set } from "@moe/priv/idb";
import { debounce } from "@moe/priv/utils";
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { parseMessageExamples } from "./MessageExamplesField";
import { CreateData } from "./schema";

export const createFormIDBKey = "restore-create-form-2024-11-24";
const persist = debounce((formData: any) => {
  set(createFormIDBKey, formData);
}, 200);

export function useRestoreCreateForm(form: UseFormReturn<CreateData>) {
  // On form change, save form data
  useEffect(() => {
    const subscription = form.watch(persist);
    return () => subscription.unsubscribe();
  }, [form]);
  useEffect(() => {
    const restore = async () => {
      const saved = await get<Partial<CreateData>>(createFormIDBKey);
      const avatar = saved?.avatar instanceof File ? saved.avatar : undefined;
      const banner = saved?.banner instanceof File ? saved.banner : undefined;

      // When we restore the avatar / banner File objects we need corresponding display URLs.
      // The previously persisted blob URLs are no longer valid after a full reload, so we must
      // generate fresh ones.
      const avatarDisplay = avatar ? URL.createObjectURL(avatar) : undefined;
      const bannerDisplay = banner ? URL.createObjectURL(banner) : undefined;

      if (saved) {
        const formData: Partial<CreateData> = {
          title: saved.title ?? "",
          tagline: saved.tagline ?? "",
          name: saved.name ?? "",
          avatar,
          banner,
          definitions: saved.definitions ?? "",
          description: saved.description ?? "",
          scenario: saved.scenario ?? "",
          greeting: saved.greeting ?? "",
          alternativeGreetings: saved.alternativeGreetings ?? [],
          messageExamples: parseMessageExamples(saved?.messageExamples ?? ""),
          isNSFW: saved.isNSFW ?? true,
          isPrivate: saved.isPrivate ?? false,
          avatarDisplay: avatarDisplay,
          bannerDisplay: bannerDisplay
        };
        form.reset(formData);
      }
    };
    restore();
  }, [form]);
}
